__turbopack_context__.v({
  "arc": "_1CyL_q_arc",
  "badge": "_1CyL_q_badge",
  "bump": "_1CyL_q_bump",
  "count": "_1CyL_q_count",
  "disc": "_1CyL_q_disc",
  "neutral": "_1CyL_q_neutral",
  "ring": "_1CyL_q_ring",
  "ringBox": "_1CyL_q_ringBox",
  "track": "_1CyL_q_track",
  "you": "_1CyL_q_you",
  "youLabel": "_1CyL_q_youLabel",
});
